import { render } from "./LabelDisclaimer.vue?vue&type=template&id=c0e500f6&scoped=true"
import script from "./LabelDisclaimer.vue?vue&type=script&lang=js"
export * from "./LabelDisclaimer.vue?vue&type=script&lang=js"

import "./LabelDisclaimer.vue?vue&type=style&index=0&id=c0e500f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0e500f6"]])

export default __exports__